export const startDateValidator = (value, formValues) => {
  const startDate = formValues.startDate;
  const endDate = formValues.endDate;

  if (startDate && endDate && startDate > endDate) {
    return 'Start Date must come before End Date';
  }

  return null;
};

export const endDateValidator = (value, formValues) => {
  const startDate = formValues.startDate;
  const endDate = formValues.endDate;

  if (startDate && endDate && startDate > endDate) {
    return 'End Date must come after Start Date';
  }

  return null;
};
